import styled from 'styled-components';
import { Input } from 'ui-components/src/components/atoms/Input';
import { SingleSelect } from 'ui-components/src/components/atoms/Select/Single';

export const Container = styled.div`
  display: flex;
  align-items: center;
  margin-top: 12px;
`;

export const StyledInput = styled(Input)`
  flex: 1;
  margin-right: 4px;
`;

export const StyledSelect = styled(SingleSelect)`
  width: 8rem;
`;
